export default "__VITE_ASSET__50__Km89__"